import React from "react";
type SectionHeaderProps = {
  number: string;
  label: string;
  title?: React.ReactNode;
  titleId?: string;
  className?: string;
};
export function SectionHeader({
  number,
  label,
  title,
  titleId,
  className = ""
}: SectionHeaderProps) {
  return <div className={className} data-id="element-350" data-mp="11ow8goobidmr">
      <p className="eyebrow flex items-center gap-3" data-id="element-351" data-mp="ws5tk4o91o2x">
        <span className="tabular-nums" data-id="element-352" data-mp="wqkymdy0w34j">{number}</span>
        <span className="h-px w-6 bg-gold/60" aria-hidden="true" data-id="element-353" data-mp="1ar5g96s7bswg" />
        <span data-id="element-354" data-mp="1apayg1c88gwl">{label}</span>
      </p>
      {title && <h2 id={titleId} className="h2-section mt-4" data-id="element-355" data-mp="15rsw4tspszxk">
          {title}
        </h2>}
    </div>;
}